<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-user-times text-primary mr-2"></i>
                    Gestión de Bajas
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Motivos de baja
                    <export-actions :rows="getUnsubscribeFilteredData()"></export-actions>
                </b-row>

                <v-client-table
                    ref="unsubscribeTable"
                    :columns="columns"
                    :data="items"
                    :options="options"
                    :theme="theme"
                    class="dataTable" md="12" lg="12" sm="12">

                    <template slot="uuid" slot-scope="props">
                        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                        <i
                            size="sm"
                            @click.stop="selectItem(props.row.uuid)"
                            v-b-modal.newItem
                            class="fa fa-pencil text-primary">
                        </i>
                    </template>
                    <template slot="active" slot-scope="props">
                        <template v-if="props.row.active">
                            Activo
                        </template>
                        <template v-else>
                            Inactivo
                        </template>
                    </template>
                </v-client-table>
                <div class="text-right">
                    <b-form-checkbox
                        type="checkbox"
                        stacked
                        v-model="hide"
                        name="hide">Mostrar inactivos
                    </b-form-checkbox>
                </div>
            </b-card>
        </b-row>

        <b-modal
            id="newItem"
            ref="newItem"
            title="Definir Motivo"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok="store"
            hide-footer
            v-model="show">

            <b-form @submit.prevent="store">

                <b-form-group class="w-100">
                    <label for="name"><strong>Nombre *</strong></label>
                    <b-input-group>
                        <b-form-input type="text" id="name" placeholder="Nombre" v-model="item.name" :required="true">
                            <i class="fa fa-user"></i></b-form-input>
                    </b-input-group>
                </b-form-group>

                <div v-if="item.uuid" class="d-inline-block float-right w-100">
                    <div class="text-right"><strong>Activo</strong></div>
                    <div v-if="item.uuid" class="text-right">
                        <label class="switch switch-3d switch-success">
                            <input type="checkbox" class="switch-input" v-model="item.active" checked>
                            <span class="switch-slider"></span>
                        </label>
                    </div>
                </div>

                <b-row class="border-top pt-3 px-3">
                    <button
                        v-if="item.uuid && mixinCheckPermission('UNSUBSCRIBE_REASON_DELETE')"
                        type="button"
                        @click="remove()"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                        sm="12">
                        Eliminar
                    </button>
                    <button
                        v-else
                        type="button"
                        @click="hideModal()"
                        class="btn btn-brand btn-secondary col-auto mr-auto btn-lg"
                        sm="12">Cerrar
                    </button>
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary col-auto btn-lg float-right"
                        sm="12"
                        v-if="mixinCheckPermissions(['UNSUBSCRIBE_REASON_NEW', 'UNSUBSCRIBE_REASON_EDIT'])">
                        Guardar
                    </button>
                </b-row>

            </b-form>
        </b-modal>

    </div>
</template>

<script>

    import VueNotifications from 'vue-notifications';
    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import ExportActions from '@/components/ExportActions';
    import {deleteUnsubscribeReason} from '@/api/unsubscribe-reason-api';

    Vue.use(ClientTable);

    export default {
        name: 'listUsers',
        components: {
            ClientTable,
            Event,
            ExportActions
        },
        mounted() {
            this.$eventHub.$on('newUnsubscribe', obj => {
                this.flush();
                this.$refs.newItem.show();
            });
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.options.texts = form.tableLabels();
            this.getItems()
        },
        beforeDestroy() {
            this.$eventHub.$off('newUnsubscribe');
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nuevo Motivo',
                        emit: 'newUnsubscribe',
                        brand: 'fa fa-user-times',
                        permissions: ['UNSUBSCRIBE_REASON_NEW']
                    },
                ],
                hide: false,
                action: null,
                items: [],
                item: {
                    name: "",
                    uuid: null,
                    active: null,
                },
                show: false,

                columns: ['uuid', 'name', 'active'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                        active: 'Activo',
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['name', 'active'],
                    filterable: ['name', 'active'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
            }
        },
        methods: {
            getItems() {
                this.$_loadingMixin_showLoading();

                let self = this;

                axios.get('unsubscribe/reasons/')
                    .then(function (response) {
                        self.$_loadingMixin_hideLoading();
                        if (response.status == "200") {
                            self.totalItems = response.data;
                            if (self.hide) {
                                self.items = response.data;
                            } else {
                                self.items = response.data.filter(i => i.active == true);
                            }
                        }
                    })
                    .catch(function (error) {
                        self.$_loadingMixin_hideLoading();
                        self.showErrorMsg();
                    });
            },
            store() {
                this.$_loadingMixin_showLoading();

                let self = this;
                let path = "unsubscribe/reasons";
                let type = "post";
                let resp = 201;
                let option = 1;

                if (this.item.uuid) {
                    path = 'unsubscribe/reasons/' + this.item.uuid;
                    type = "post";
                    resp = 200;
                    option = 2;
                }

                axios({method: type, url: path, data: this.item})
                    .then(function (response) {
                        self.$_loadingMixin_hideLoading();
                        if (response.status == resp) {
                            self.show = false;
                            self.showSuccessMsg();
                            self.flush();
                            self.getItems();
                        }
                    })
                    .catch(function (error) {
                        self.$_loadingMixin_hideLoading();
                        self.showErrorMsg()
                    });

                this.show = false;
            },
            remove() {
                swal({
                    title: '¿Desea eliminar el motivo de baja?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        deleteUnsubscribeReason(this.item.uuid)
                            .then(() => {
                                this.flush();
                                this.getItems();
                                this.$_notificationMixin_success('Operación completada', 'El motivo de baja ha sido eliminado');
                                this.$_loadingMixin_hideLoading();
                                this.show = false
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', 'No se ha podido eliminar el motivo de baja');
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            },
            selectItem(uuid) {
                let dp = this.items.find(function (dep) {
                    return dep.uuid == uuid;
                });
                this.item.uuid = dp.uuid;
                this.item.name = dp.name;
                this.item.active = dp.active;
            },
            flush() {
                this.item.uuid = 0;
                this.item.name = "";
                this.item.active = false;
            },
            getRowCount(items) {
                return items.length;
            },
            hideModal() {
                this.$refs.newItem.hide();
            },
            getUnsubscribeFilteredData() {
                if (!!this.$refs.unsubscribeTable) {
                    return this.$refs.unsubscribeTable.allFilteredData.map(unsubscribe => ({
                        'Nombre': unsubscribe.name,
                        'Activo': (unsubscribe.active ? 'activo' : 'inactivo'),
                    }));
                } else {
                    return [];
                }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Motivo guardado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Acceso denegado',
                message: 'Algo salió mal'
            }
        },
        watch: {
            hide() {
                if (this.hide) {
                    this.items = this.totalItems;
                } else {
                    this.items = this.totalItems.filter(i => i.active == true);

                }
            }
        }

    }
</script>